__webpack_require__.p = "/mod-asteroids/";